
import Vue from 'vue'
import {NewGatewaysApiFunc, setAccessToken} from '@/api'
import { Gateway } from '@/models'

import GatewayList from './components/GatewayList.vue'
import TheTemplate from '../TheTemplate.vue'
import SearchForm from '@/components/BaseSearchForm.vue'
import Pager from '@/components/BasePager.vue'

export type FilterCondition = {
  status?: string;
  word?: string;
}

export type DataType = {
  gateways: Array<Gateway>;
  filterCondition: FilterCondition;
  totalPage: number;
  currentPage: number;
  defaultIntervalId: number | undefined;
  currentPageIntervalId: number | undefined;
}

const SIX_SECONDS = 6000;

export default Vue.extend({
  name: 'GatewayListScreen',

  components: {
    TheTemplate,
    SearchForm,
    GatewayList,
    Pager
  },

  data(): DataType {
    return {
      gateways: [],
      filterCondition: {
        word: '',
        status: '',
      },
      totalPage: 0,
      currentPage: 0,
      defaultIntervalId: undefined,
      currentPageIntervalId: undefined,
    }
  },

  computed: {
    isAdmin(): boolean {
      return this.$auth.role === "admin"
    }
  },

  mounted() {
    this.fetchGateways()
    this.defaultIntervalId = window.setInterval(() => this.fetchGateways(), SIX_SECONDS)
  },

  destroyed() {
    window.clearInterval(this.defaultIntervalId)
    this.defaultIntervalId = undefined
    window.clearInterval(this.currentPageIntervalId)
    this.currentPageIntervalId = undefined
  },

  watch: {
    $route(to) {
      if (to.params.updated === 'true') {
        this.fetchGateways(this.currentPage)
      }
    }
  },

  methods: {
    async fetchGateways(page?: number): Promise<void> {
      const companyId = this.$auth.companyId
      if (!companyId) {
        this.$router.replace({name: 'login'})
        return
      }
      const filterString: string = JSON.stringify({
        q: this.filterCondition.word,
        status: this.filterCondition.status,
      })
        setAccessToken(this.$auth.accessToken)
        const { data, err } = await NewGatewaysApiFunc().listGateways(companyId, filterString, page)

      if (err != null) {
        this.$handleApiError(err, () => {
          this.fetchGateways(page)
        })
        return
      }

      this.gateways = data.list
      this.currentPage = data.currentPage || 1
      this.totalPage = data.totalPage || 1
    },

    updateFilterCondition(condition?: FilterCondition): void {
      this.filterCondition = Object.assign(this.filterCondition, condition)
    },

    changePage(page: number): void {
      window.clearInterval(this.defaultIntervalId)
      this.defaultIntervalId = undefined
      window.clearInterval(this.currentPageIntervalId)
      this.currentPageIntervalId = undefined
      this.fetchGateways(page)
      this.currentPageIntervalId = window.setInterval(() => this.fetchGateways(page), SIX_SECONDS)
    }
  }
})
